import script from "./ProgramDashboardCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramDashboardCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramDashboardCard.vue?vue&type=style&index=0&id=81cdb2a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81cdb2a2"]])

export default __exports__